import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailStoriesChildProps as Props } from './types';
import { getCompanyPostDetails } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [updatedAt, setUpdatedAt] = useState<string>('');
  const [image, setImage] = useState<{url: string} | null>(null);
  const [postTitle, setPostTitle] = useState<string>('');

  useEffect(() => {
    let aborted = false;

    const fetchDetails = async () => {
      try {
        const response = await getCompanyPostDetails(props.id);
        if (!aborted) {
          setUpdatedAt(response.updatedAt || '');
          setImage(response.image ?? null);
          setPostTitle(response.postTitle || '');
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetails();
    return () => {
      aborted = true;
    };
  }, [props.id]);

  return (
    <Presentation
      id={props.id}
      companyId={props.companyId}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
      updatedAt={updatedAt}
      image={image}
      postTitle={postTitle}
    />
  );
};